import { AfterViewInit, Component, OnInit } from '@angular/core';

declare const google:any;
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUSComponent implements OnInit, AfterViewInit {

  constructor() { }
  map:any;
  marker:any;

  ngAfterViewInit(): void {

    // // 1- The location of desired.
    // const mdicalCenterLocation = { lat: 18.21140326290951, lng: 42.563139042327734 };

    // // 2- apply position to map.
    //  this.map = new google.maps.Map(document.getElementById("map"), {
    //   center: mdicalCenterLocation,
    //   zoom: 25
    // });

    // // 3- The marker, positioned at desired location.
    // this.marker = new google.maps.Marker({
    //   position: mdicalCenterLocation,
    //   map: this.map,
    // });

  }

  ngOnInit() {
  }


}
